/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MasterRouteRouteImport } from './routes/master/route'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SandboxRouteImport } from './routes/sandbox'
import { Route as AgendarSlugRouteImport } from './routes/agendar.$slug'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAgendaRouteImport } from './routes/app/agenda'
import { Route as AppCustomersRouteImport } from './routes/app/customers'
import { Route as AppFinancialRouteImport } from './routes/app/financial'
import { Route as AppGrowthRouteImport } from './routes/app/growth'
import { Route as AppInventoryRouteImport } from './routes/app/inventory'
import { Route as AppQuotesRouteImport } from './routes/app/quotes'
import { Route as AppServicesRouteImport } from './routes/app/services'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppSurveysRouteImport } from './routes/app/surveys'
import { Route as AppTeamRouteImport } from './routes/app/team'
import { Route as AppTvRouteImport } from './routes/app/tv'
import { Route as AppTvMidiaRouteImport } from './routes/app/tv-midia'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as MasterIndexRouteImport } from './routes/master/index'
import { Route as MasterPlansRouteImport } from './routes/master/plans'
import { Route as MasterSettingsRouteImport } from './routes/master/settings'
import { Route as MasterTenantsRouteImport } from './routes/master/tenants'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MasterRouteRoute = MasterRouteRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SandboxRoute = SandboxRouteImport.update({
  id: '/sandbox',
  path: '/sandbox',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendarSlugRoute = AgendarSlugRouteImport.update({
  id: '/agendar/$slug',
  path: '/agendar/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAgendaRoute = AppAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFinancialRoute = AppFinancialRouteImport.update({
  id: '/financial',
  path: '/financial',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGrowthRoute = AppGrowthRouteImport.update({
  id: '/growth',
  path: '/growth',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppQuotesRoute = AppQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppServicesRoute = AppServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSurveysRoute = AppSurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTvRoute = AppTvRouteImport.update({
  id: '/tv',
  path: '/tv',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTvMidiaRoute = AppTvMidiaRouteImport.update({
  id: '/tv-midia',
  path: '/tv-midia',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const MasterIndexRoute = MasterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MasterRouteRoute,
} as any)
const MasterPlansRoute = MasterPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => MasterRouteRoute,
} as any)
const MasterSettingsRoute = MasterSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => MasterRouteRoute,
} as any)
const MasterTenantsRoute = MasterTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => MasterRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/master': typeof MasterRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/sandbox': typeof SandboxRoute
  '/agendar/$slug': typeof AgendarSlugRoute
  '/app/agenda': typeof AppAgendaRoute
  '/app/customers': typeof AppCustomersRoute
  '/app/financial': typeof AppFinancialRoute
  '/app/growth': typeof AppGrowthRoute
  '/app/inventory': typeof AppInventoryRoute
  '/app/quotes': typeof AppQuotesRoute
  '/app/services': typeof AppServicesRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/surveys': typeof AppSurveysRoute
  '/app/team': typeof AppTeamRoute
  '/app/tv': typeof AppTvRoute
  '/app/tv-midia': typeof AppTvMidiaRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/$token': typeof InviteTokenRoute
  '/master/plans': typeof MasterPlansRoute
  '/master/settings': typeof MasterSettingsRoute
  '/master/tenants': typeof MasterTenantsRoute
  '/app/': typeof AppIndexRoute
  '/master/': typeof MasterIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/sandbox': typeof SandboxRoute
  '/agendar/$slug': typeof AgendarSlugRoute
  '/app/agenda': typeof AppAgendaRoute
  '/app/customers': typeof AppCustomersRoute
  '/app/financial': typeof AppFinancialRoute
  '/app/growth': typeof AppGrowthRoute
  '/app/inventory': typeof AppInventoryRoute
  '/app/quotes': typeof AppQuotesRoute
  '/app/services': typeof AppServicesRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/surveys': typeof AppSurveysRoute
  '/app/team': typeof AppTeamRoute
  '/app/tv': typeof AppTvRoute
  '/app/tv-midia': typeof AppTvMidiaRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/$token': typeof InviteTokenRoute
  '/master/plans': typeof MasterPlansRoute
  '/master/settings': typeof MasterSettingsRoute
  '/master/tenants': typeof MasterTenantsRoute
  '/app': typeof AppIndexRoute
  '/master': typeof MasterIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/master': typeof MasterRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/sandbox': typeof SandboxRoute
  '/agendar/$slug': typeof AgendarSlugRoute
  '/app/agenda': typeof AppAgendaRoute
  '/app/customers': typeof AppCustomersRoute
  '/app/financial': typeof AppFinancialRoute
  '/app/growth': typeof AppGrowthRoute
  '/app/inventory': typeof AppInventoryRoute
  '/app/quotes': typeof AppQuotesRoute
  '/app/services': typeof AppServicesRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/surveys': typeof AppSurveysRoute
  '/app/team': typeof AppTeamRoute
  '/app/tv': typeof AppTvRoute
  '/app/tv-midia': typeof AppTvMidiaRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/$token': typeof InviteTokenRoute
  '/master/plans': typeof MasterPlansRoute
  '/master/settings': typeof MasterSettingsRoute
  '/master/tenants': typeof MasterTenantsRoute
  '/app/': typeof AppIndexRoute
  '/master/': typeof MasterIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/master'
    | '/login'
    | '/onboarding'
    | '/sandbox'
    | '/agendar/$slug'
    | '/app/agenda'
    | '/app/customers'
    | '/app/financial'
    | '/app/growth'
    | '/app/inventory'
    | '/app/quotes'
    | '/app/services'
    | '/app/settings'
    | '/app/surveys'
    | '/app/team'
    | '/app/tv'
    | '/app/tv-midia'
    | '/auth/callback'
    | '/invite/$token'
    | '/master/plans'
    | '/master/settings'
    | '/master/tenants'
    | '/app/'
    | '/master/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/onboarding'
    | '/sandbox'
    | '/agendar/$slug'
    | '/app/agenda'
    | '/app/customers'
    | '/app/financial'
    | '/app/growth'
    | '/app/inventory'
    | '/app/quotes'
    | '/app/services'
    | '/app/settings'
    | '/app/surveys'
    | '/app/team'
    | '/app/tv'
    | '/app/tv-midia'
    | '/auth/callback'
    | '/invite/$token'
    | '/master/plans'
    | '/master/settings'
    | '/master/tenants'
    | '/app'
    | '/master'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/master'
    | '/login'
    | '/onboarding'
    | '/sandbox'
    | '/agendar/$slug'
    | '/app/agenda'
    | '/app/customers'
    | '/app/financial'
    | '/app/growth'
    | '/app/inventory'
    | '/app/quotes'
    | '/app/services'
    | '/app/settings'
    | '/app/surveys'
    | '/app/team'
    | '/app/tv'
    | '/app/tv-midia'
    | '/auth/callback'
    | '/invite/$token'
    | '/master/plans'
    | '/master/settings'
    | '/master/tenants'
    | '/app/'
    | '/master/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  MasterRouteRoute: typeof MasterRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  SandboxRoute: typeof SandboxRoute
  AgendarSlugRoute: typeof AgendarSlugRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/master': {
      id: '/master'
      path: '/master'
      fullPath: '/master'
      preLoaderRoute: typeof MasterRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sandbox': {
      id: '/sandbox'
      path: '/sandbox'
      fullPath: '/sandbox'
      preLoaderRoute: typeof SandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agendar/$slug': {
      id: '/agendar/$slug'
      path: '/agendar/$slug'
      fullPath: '/agendar/$slug'
      preLoaderRoute: typeof AgendarSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/agenda': {
      id: '/app/agenda'
      path: '/agenda'
      fullPath: '/app/agenda'
      preLoaderRoute: typeof AppAgendaRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/customers': {
      id: '/app/customers'
      path: '/customers'
      fullPath: '/app/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/financial': {
      id: '/app/financial'
      path: '/financial'
      fullPath: '/app/financial'
      preLoaderRoute: typeof AppFinancialRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/growth': {
      id: '/app/growth'
      path: '/growth'
      fullPath: '/app/growth'
      preLoaderRoute: typeof AppGrowthRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/inventory': {
      id: '/app/inventory'
      path: '/inventory'
      fullPath: '/app/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/quotes': {
      id: '/app/quotes'
      path: '/quotes'
      fullPath: '/app/quotes'
      preLoaderRoute: typeof AppQuotesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/services': {
      id: '/app/services'
      path: '/services'
      fullPath: '/app/services'
      preLoaderRoute: typeof AppServicesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/surveys': {
      id: '/app/surveys'
      path: '/surveys'
      fullPath: '/app/surveys'
      preLoaderRoute: typeof AppSurveysRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/team': {
      id: '/app/team'
      path: '/team'
      fullPath: '/app/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/tv': {
      id: '/app/tv'
      path: '/tv'
      fullPath: '/app/tv'
      preLoaderRoute: typeof AppTvRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/tv-midia': {
      id: '/app/tv-midia'
      path: '/tv-midia'
      fullPath: '/app/tv-midia'
      preLoaderRoute: typeof AppTvMidiaRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/master/': {
      id: '/master/'
      path: '/'
      fullPath: '/master/'
      preLoaderRoute: typeof MasterIndexRouteImport
      parentRoute: typeof MasterRouteRoute
    }
    '/master/plans': {
      id: '/master/plans'
      path: '/plans'
      fullPath: '/master/plans'
      preLoaderRoute: typeof MasterPlansRouteImport
      parentRoute: typeof MasterRouteRoute
    }
    '/master/settings': {
      id: '/master/settings'
      path: '/settings'
      fullPath: '/master/settings'
      preLoaderRoute: typeof MasterSettingsRouteImport
      parentRoute: typeof MasterRouteRoute
    }
    '/master/tenants': {
      id: '/master/tenants'
      path: '/tenants'
      fullPath: '/master/tenants'
      preLoaderRoute: typeof MasterTenantsRouteImport
      parentRoute: typeof MasterRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppAgendaRoute: typeof AppAgendaRoute
  AppCustomersRoute: typeof AppCustomersRoute
  AppFinancialRoute: typeof AppFinancialRoute
  AppGrowthRoute: typeof AppGrowthRoute
  AppInventoryRoute: typeof AppInventoryRoute
  AppQuotesRoute: typeof AppQuotesRoute
  AppServicesRoute: typeof AppServicesRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSurveysRoute: typeof AppSurveysRoute
  AppTeamRoute: typeof AppTeamRoute
  AppTvRoute: typeof AppTvRoute
  AppTvMidiaRoute: typeof AppTvMidiaRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAgendaRoute: AppAgendaRoute,
  AppCustomersRoute: AppCustomersRoute,
  AppFinancialRoute: AppFinancialRoute,
  AppGrowthRoute: AppGrowthRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppQuotesRoute: AppQuotesRoute,
  AppServicesRoute: AppServicesRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSurveysRoute: AppSurveysRoute,
  AppTeamRoute: AppTeamRoute,
  AppTvRoute: AppTvRoute,
  AppTvMidiaRoute: AppTvMidiaRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface MasterRouteRouteChildren {
  MasterPlansRoute: typeof MasterPlansRoute
  MasterSettingsRoute: typeof MasterSettingsRoute
  MasterTenantsRoute: typeof MasterTenantsRoute
  MasterIndexRoute: typeof MasterIndexRoute
}

const MasterRouteRouteChildren: MasterRouteRouteChildren = {
  MasterPlansRoute: MasterPlansRoute,
  MasterSettingsRoute: MasterSettingsRoute,
  MasterTenantsRoute: MasterTenantsRoute,
  MasterIndexRoute: MasterIndexRoute,
}

const MasterRouteRouteWithChildren = MasterRouteRoute._addFileChildren(
  MasterRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  MasterRouteRoute: MasterRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  SandboxRoute: SandboxRoute,
  AgendarSlugRoute: AgendarSlugRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
